import { PublicChannelVideos } from '@wix/wix-vod-api-site-based/public';
import { toError } from '../../parsers/to-error';
import { parseVideoItem } from '../../parsers/video-item';
export class PublicChannelVideosService {
    constructor(httpClient, baseUrl) {
        this.publicChannelVideos = new PublicChannelVideos(httpClient, baseUrl);
    }
    parseListChannelResponse(response, sort) {
        return {
            ...response,
            data: _.map(response.data.items, parseVideoItem),
            sort,
            paging: {
                size: response.data.items.length,
                cursor: response.data.cursor,
            },
        };
    }
    parseChannelVideoResponse(response) {
        return {
            ...response,
            data: parseVideoItem(response.data),
        };
    }
    async listChannelVideos({ channelId, query, tag, category, mediaType, sort, paging, templateMetaSiteId, }) {
        try {
            const response = await this.publicChannelVideos.getList({
                channelId,
                query,
                tag,
                category,
                mediaType,
                sort,
                paging,
                templateMetaSiteId,
            });
            return this.parseListChannelResponse(response, sort);
        }
        catch (error) {
            return toError(error);
        }
    }
    async getChannelVideoById(channelId, videoId, requestOptions) {
        try {
            const response = await this.publicChannelVideos.getChannelVideoById(channelId, videoId, requestOptions);
            return this.parseChannelVideoResponse(response);
        }
        catch (error) {
            return toError(error);
        }
    }
}
//# sourceMappingURL=channel-videos.js.map